// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ActivityDrawer.css */

.activity-drawer {
  position: fixed;
  top: 0;
  left: 220px; /* Start after the left nav */
  right: 0;
  bottom: 0;
  background-color: #FFFFFF;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  transform: translateY(100%);
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  will-change: transform;
}

.activity-drawer-open {
  transform: translateY(0);
}

/* Header with back button */
.activity-drawer-header {
  display: flex;
  align-items: center;
  padding: 20px 40px;
  background-color: #FFFFFF;
  border-bottom: 1px solid #E5E5E5;
  flex-shrink: 0;
}

.activity-drawer-back-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background-color: transparent;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #0077C5;
  transition: background-color 0.2s ease;
}

.activity-drawer-back-btn:hover {
  background-color: #F4F4F4;
}

.activity-drawer-back-btn:focus {
  outline: 2px solid #0077C5;
  outline-offset: 2px;
}

.activity-drawer-back-btn svg {
  width: 24px;
  height: 24px;
  color: #0077C5;
}

/* Content area with iframe */
.activity-drawer-content {
  flex: 1;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}

.activity-drawer-iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}

.activity-drawer-iframe-hidden {
  visibility: hidden;
  position: absolute;
}

/* Loading State */
.activity-drawer-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  color: #6B6B6B;
}

.activity-drawer-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #E5E5E5;
  border-top-color: #0077C5;
  border-radius: 50%;
  animation: activity-drawer-spin 1s linear infinite;
}

@keyframes activity-drawer-spin {
  to { transform: rotate(360deg); }
}

/* Error State */
.activity-drawer-error {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  max-width: 400px;
  padding: 32px;
  text-align: center;
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
}

.activity-drawer-error svg {
  color: #D52B1E;
}

.activity-drawer-error h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #393A3D;
}

.activity-drawer-error p {
  margin: 0;
  font-size: 14px;
  color: #6B6B6B;
  line-height: 1.5;
}

.activity-drawer-error-actions {
  display: flex;
  gap: 12px;
  margin-top: 12px;
}

.activity-drawer-retry-btn {
  padding: 10px 24px;
  background-color: #0077C5;
  color: #FFFFFF;
  border: none;
  border-radius: 8px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.activity-drawer-retry-btn:hover {
  background-color: #005FA3;
}

.activity-drawer-close-btn {
  padding: 10px 24px;
  background-color: transparent;
  color: #0077C5;
  border: 2px solid #0077C5;
  border-radius: 8px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.activity-drawer-close-btn:hover {
  background-color: #F0F7FC;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .activity-drawer-header {
    padding: 16px 24px;
  }

  .activity-drawer-back-btn {
    font-size: 14px;
    padding: 8px 16px;
  }
}

/* On mobile where nav is hidden, drawer should be full width */
@media (max-width: 680px) {
  .activity-drawer {
    left: 0;
  }
}

/* Timeout Error State */
.activity-timeout-error {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 40px;
  text-align: center;
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  max-width: 588px;
  width: 100%;
}

.activity-timeout-error-image {
  width: 440px;
  height: 293px;
  object-fit: contain;
}

.activity-timeout-error-title {
  margin: 0;
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 800;
  font-size: 48px;
  line-height: 1.2;
  color: #236CFF;
  letter-spacing: -0.24px;
}

.activity-timeout-error-message {
  margin: 0;
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 1.6;
  color: #21262A;
}

.activity-timeout-error-button {
  padding: 10px 24px;
  background-color: #FFFFFF;
  color: #00254B;
  border: 2px solid #00254B;
  border-radius: 9999px;
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 28px;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
  min-width: 136px;
}

.activity-timeout-error-button:hover {
  background-color: #00254B;
  color: #FFFFFF;
}

`, "",{"version":3,"sources":["webpack://./src/styles/ActivityDrawer.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB;EACE,eAAe;EACf,MAAM;EACN,WAAW,EAAE,6BAA6B;EAC1C,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uDAAuD;EACvD,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kFAAkF;EAClF,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,kFAAkF;AACpF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA,+DAA+D;AAC/D;EACE;IACE,OAAO;EACT;AACF;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,kFAAkF;EAClF,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,uDAAuD;EACvD,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB","sourcesContent":["/* ActivityDrawer.css */\n\n.activity-drawer {\n  position: fixed;\n  top: 0;\n  left: 220px; /* Start after the left nav */\n  right: 0;\n  bottom: 0;\n  background-color: #FFFFFF;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  transform: translateY(100%);\n  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: transform;\n}\n\n.activity-drawer-open {\n  transform: translateY(0);\n}\n\n/* Header with back button */\n.activity-drawer-header {\n  display: flex;\n  align-items: center;\n  padding: 20px 40px;\n  background-color: #FFFFFF;\n  border-bottom: 1px solid #E5E5E5;\n  flex-shrink: 0;\n}\n\n.activity-drawer-back-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  background-color: transparent;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  color: #0077C5;\n  transition: background-color 0.2s ease;\n}\n\n.activity-drawer-back-btn:hover {\n  background-color: #F4F4F4;\n}\n\n.activity-drawer-back-btn:focus {\n  outline: 2px solid #0077C5;\n  outline-offset: 2px;\n}\n\n.activity-drawer-back-btn svg {\n  width: 24px;\n  height: 24px;\n  color: #0077C5;\n}\n\n/* Content area with iframe */\n.activity-drawer-content {\n  flex: 1;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  position: relative;\n}\n\n.activity-drawer-iframe {\n  width: 100%;\n  height: 100%;\n  border: none;\n  display: block;\n}\n\n.activity-drawer-iframe-hidden {\n  visibility: hidden;\n  position: absolute;\n}\n\n/* Loading State */\n.activity-drawer-loading {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  color: #6B6B6B;\n}\n\n.activity-drawer-spinner {\n  width: 48px;\n  height: 48px;\n  border: 4px solid #E5E5E5;\n  border-top-color: #0077C5;\n  border-radius: 50%;\n  animation: activity-drawer-spin 1s linear infinite;\n}\n\n@keyframes activity-drawer-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Error State */\n.activity-drawer-error {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  max-width: 400px;\n  padding: 32px;\n  text-align: center;\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.activity-drawer-error svg {\n  color: #D52B1E;\n}\n\n.activity-drawer-error h3 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #393A3D;\n}\n\n.activity-drawer-error p {\n  margin: 0;\n  font-size: 14px;\n  color: #6B6B6B;\n  line-height: 1.5;\n}\n\n.activity-drawer-error-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 12px;\n}\n\n.activity-drawer-retry-btn {\n  padding: 10px 24px;\n  background-color: #0077C5;\n  color: #FFFFFF;\n  border: none;\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.activity-drawer-retry-btn:hover {\n  background-color: #005FA3;\n}\n\n.activity-drawer-close-btn {\n  padding: 10px 24px;\n  background-color: transparent;\n  color: #0077C5;\n  border: 2px solid #0077C5;\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s ease, color 0.2s ease;\n}\n\n.activity-drawer-close-btn:hover {\n  background-color: #F0F7FC;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .activity-drawer-header {\n    padding: 16px 24px;\n  }\n\n  .activity-drawer-back-btn {\n    font-size: 14px;\n    padding: 8px 16px;\n  }\n}\n\n/* On mobile where nav is hidden, drawer should be full width */\n@media (max-width: 680px) {\n  .activity-drawer {\n    left: 0;\n  }\n}\n\n/* Timeout Error State */\n.activity-timeout-error {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 24px;\n  padding: 40px;\n  text-align: center;\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  max-width: 588px;\n  width: 100%;\n}\n\n.activity-timeout-error-image {\n  width: 440px;\n  height: 293px;\n  object-fit: contain;\n}\n\n.activity-timeout-error-title {\n  margin: 0;\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 800;\n  font-size: 48px;\n  line-height: 1.2;\n  color: #236CFF;\n  letter-spacing: -0.24px;\n}\n\n.activity-timeout-error-message {\n  margin: 0;\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 1.6;\n  color: #21262A;\n}\n\n.activity-timeout-error-button {\n  padding: 10px 24px;\n  background-color: #FFFFFF;\n  color: #00254B;\n  border: 2px solid #00254B;\n  border-radius: 9999px;\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 28px;\n  cursor: pointer;\n  transition: background-color 0.2s ease, color 0.2s ease;\n  min-width: 136px;\n}\n\n.activity-timeout-error-button:hover {\n  background-color: #00254B;\n  color: #FFFFFF;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
